var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cs-switcher",
    class: (_class = {}, _class[_vm.size] = true, _class.checked = _vm.internalValue, _class.disabled = _vm.internalDisabled, _class),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "cs-switcher-background"
  }), _c('div', {
    staticClass: "cs-switcher-button"
  }), _vm.label ? _c('div', {
    staticClass: "cs-switcher-label",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }